import { render, staticRenderFns } from "./RegraCobrancaAddNew.vue?vue&type=template&id=418217cb&"
import script from "./RegraCobrancaAddNew.vue?vue&type=script&lang=js&"
export * from "./RegraCobrancaAddNew.vue?vue&type=script&lang=js&"
import style0 from "./RegraCobrancaAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports